import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import Text from 'components/_core/Text';

interface CardsGroupDescriptionProps {
  description: string;
}

const CardsGroupDescription: FC<CardsGroupDescriptionProps> = ({
  description,
}) => (
  <Box marginBottom="space-8">
    <Text size="sm" variant="light">
      {description}
    </Text>
  </Box>
);

export default CardsGroupDescription;
